<template>
  <!--<div class="box" :contenteditable="isEdit" v-html="innerText" v-focus="editFocus"-->
  <!--<div>-->
  <div
    v-focus="editFocus"
    class="box"
    ref="boxs"
    :contenteditable="edit"
    style="-webkit-user-select:text"
    :placeholder="$t('im.consultTips')"
    @input="changeTxt"
    @focus="keyboard"
    @blur="inputBlur"
    v-html="innerText"
    @click="focusClick"
  />
  <!--<div class="box" :contenteditable="edit" v-html="innerText" v-focus="editFocus" style="-webkit-user-select:text"-->
  <!--placeholder="......"-->
  <!--@input="changeTxt" @focus="lock=true"-->
  <!--@blur="lock=false"></div>-->
  <!--</div>-->

</template>
<script>
import { throttle } from '@/utils/common';
let type = true;
let that;
export default {
  //
  directives: {
    focus: {
      update(el, { value }) {
        if (value) {
          if(type && el.stopPropagation){
              el.stopPropagation();
              return false;
          }
          // if (window.getSelection) { // ie11 10 9 ff safari
          //   if(this.lock){
          //     el.focus() // ff
          //   }
          //   var range = window.getSelection()// range
          //   range.selectAllChildren(el)// range obj
          //   range.collapseToEnd()//
          // } else if (document.selection) { // ie10 9 8 7 6 5
          //   var range = document.selection.createRange()//
          //   range.moveToElementText(el)// rangeobj
          //   range.collapse(true)//
          //   range.select()
          // }
        } else {
          el.blur()
        }
      }
    }
  },
  props: {
    child: {
      type: Object,
      default: {
        html: ''
      }
    },
    sendType:{
      type:Boolean,
    },
    isShowFaceList:{
      type:Boolean,
    },
    isShowMoreFunctions:{
      type:Boolean,
    },
    // isEdit:{
    //   type:Boolean,
    //   default:true
    // },
    editFocus: {
      type: Boolean,
      default: true
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerText: this.child.html,
      lock: false,
      // 光标位置
      lastEditRange:0,
      // 输入框 获得焦点时 消息滚动到底 定时
      scorllTimer:null
    }
  },
  watch: {
    child: {
      handler(newValue, oldValue) {
        if (!this.lock) {
          this.innerText = this.child.html;
          // let txt = document
          // console.log();
          if(this.child.html==''&&this.$refs.boxs.innerHTML!=''){
            this.$refs.boxs.innerHTML  = '';
            this.lastEditRange = 0;
            // if (window.getSelection) { // ie11 10 9 ff safari
            //   var range = window.getSelection()// range
            //   // range.selectAllChildren(el)// range obj
            //   range.collapseToEnd()//
            //   range.removeAllRanges()
            // } else if (document.selection) { // ie10 9 8 7 6 5
            //   var range = document.selection.createRange()//
            //   // range.moveToElementText(el)// rangeobj
            //   range.collapse(true)//
            //   range.select()
            //   range.removeAllRanges()
            // }
          }
          this.$emit(this.innerText,this.child.html)
          this.$forceUpdate();
        }
        if(this.sendType && !this.child.html){
          this.$parent.sendType = false;
          this.innerText = "";
          this.$refs.boxs.innerHTML  = '';
        }
        // this.$parent.
      },
      deep: true
    },
    isShowFaceList:{
      handler(){
        type = this.isShowFaceList || this.isShowMoreFunctions;
      }
    },
    isShowMoreFunctions:{
      handler(){
        type = this.isShowFaceList || this.isShowMoreFunctions;
      }
    }

  },
  created(){
    that = this;

  },
  methods: {
    inputBlur(event){
      
      if(this.lock){
        // 阻止 blur 事件
        event.preventDefault();
        // 立即对当前可编辑元素设置焦点
        this.$refs.boxs.focus();
      }
      // if (window.getSelection) { // ie11 10 9 ff safari
      //   var range = window.getSelection()// range
        
      //   // range.selectAllChildren(el)// range obj
      //   range.collapseToEnd()//
      //   range.removeAllRanges()
      // } else if (document.selection) { // ie10 9 8 7 6 5
      //   var range = document.selection.createRange()//
      //   // range.moveToElementText(el)// rangeobj
      //   range.collapse(true)//
      //   range.select()
      //   range.removeAllRanges()
      // }
      // this.lock = false;
      clearInterval(this.scorllTimer)
    },
    keyboard() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        document.body.scrollTop = document.body.scrollHeight
      }      
      this.lock = true;
    },
    focusClick(){
      if(this.scorllTimer){
        clearInterval(this.scorllTimer);
      }
      let self = this;
      let startTopArr=[];
      this.scorllTimer = setInterval(()=>{
        self.$parent.$refs.scroller.scrollTo({
          top:self.$parent.$refs.msgListEle.$el.scrollHeight,
          behavior:"smooth"
        })
        startTopArr.push(self.$parent.$refs.scroller.scrollTop);
        if(startTopArr.length >= 2){
            if(startTopArr[startTopArr.length - 1] != startTopArr[startTopArr.length - 2]&&startTopArr[startTopArr.length - 1] > startTopArr[startTopArr.length - 2]){
              self.$parent.$refs.scroller.scrollTo({
                top:self.$parent.$refs.msgListEle.$el.scrollHeight,
                behavior:"smooth"
              })
            }
            // console.log(startTopArr.length >= 3 , (startTopArr[0] < startTopArr[startTopArr.length - 1]) , startTopArr[startTopArr.length - 1].toFixed(0) == startTopArr[startTopArr.length - 2].toFixed(0));
            // console.log(startTopArr[startTopArr.length - 1].toFixed(0) ,'----', startTopArr[startTopArr.length - 2].toFixed(0));
            if(startTopArr.length >= 3 && (startTopArr[0] < startTopArr[startTopArr.length - 1]) && (startTopArr[startTopArr.length - 1].toFixed(0) == startTopArr[startTopArr.length - 2].toFixed(0))){
              clearInterval(self.scorllTimer);
              startTopArr = [];
            }
        }
      },500)
      self.$parent.$refs.scroller.addEventListener('touchstart', function(){
        clearInterval(self.scorllTimer);
        self.$parent.$refs.scroller.removeEventListener('touchstart');
      }) 
    },
    changeTxt:throttle((e) =>{
      if (e == '') {
        that.$el.innerHTML = e
        that.child.html = e
      } else {
        // console.log(e);
        that.child.html = that.$el.innerHTML
      }
    },500)
  }
}
</script>
<style scoped lang="scss">
  .box{
    font-size: 0.6rem;
  -webkit-user-select:all;
  // width:65%;
  padding:0.28rem 0.5rem;

  // display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  // height: 100%;
  max-height: 1.6rem;
  overflow: auto;
  outline-style:none;
  img{
    float: left;
  }

  *{
    -webkit-user-select:all
  }
}
.box:empty:before{
  content:attr(placeholder);
  color:#c7c7c7;
  padding-left:0.25rem;
}
.box:focus:before{
  content:none;
}
</style>
<style>
  .box img{
    max-width: 1rem !important;
  }
</style>
